export function translate(message: string, ...params: any) {
  if (Array.isArray(params)) {
    params.forEach((item) => {
      message = message.replace(":?", item)
    })
  }
  return message
}
